export default {
      id: "ar_menus_scolaires-usage",
      viewBox: "0 0 90 75",
      url: "../dist/images/" + "sprite.svg#ar_menus_scolaires-usage",
      toString: function () {
        return this.url;
      }
    }